export const attendee = '/MersetaExternalAttendee';
export const allocatedAttendees = attendee + '/AllocatedAttendees/';
export const stipend = attendee + '/Stipend';
export const getAllUnassociatedAttendee = attendee + '/AllUnassociatedAttendee/';
